<template>
  <div class="FilterBoxTransation">
    <el-form :model="ruleForm" ref="ruleForm" @submit.prevent v-on:submit.prevent>
      <div class="viewFilter">
        <el-row :gutter="20">
          <el-col :sm="24" :md="8">
            <el-form-item prop="marketplace_manager_id" label="Gerente de Marketplace">
              <SelectSearchGerenteMarketplace :disabled="$can('2|6')" :model="ruleForm.marketplace_manager_id" :isEdit="false" @handleValue="(x) => {$set(ruleForm, 'marketplace_manager_id', x)}" />
            </el-form-item>
          </el-col>
          <el-col :sm="24" :md="8">
            <el-form-item prop="marketplace_id" label="Marketplace">
              <SelectSearchMarketplace :disabled="$can('2|4|5')" :model="ruleForm.marketplace_id" :isEdit="false" @handleValue="(x) => {$set(ruleForm, 'marketplace_id', x)}" />
            </el-form-item>
          </el-col>
          <el-col :sm="24" :md="8">
            <el-form-item prop="department_store_id" label="Estabelecimento Comercial">
              <SelectSearchDepartamentStore :disabled="$can('5')" :model="ruleForm.department_store_id" :isEdit="false" @handleValue="(x) => {$set(ruleForm, 'department_store_id', x)}" />
            </el-form-item>
          </el-col>
          <el-col :sm="24" :md="7">
            <el-form-item prop="init_date" label="Período de Lançamento">
              <el-date-picker
                format="dd/MM/yyyy" value-format="yyyy-MM-dd"
                style="width: 100%"
                v-model="ruleForm.init_date"
                type="daterange"
                start-placeholder="Inicio" end-placeholder="Fim">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :sm="24" :md="7">
            <el-form-item prop="init_date_payment" label="Período de Pagamento">
              <el-date-picker
                  format="dd/MM/yyyy" value-format="yyyy-MM-dd"
                  style="width: 100%"
                  v-model="ruleForm.init_date_payment"
                  type="daterange"
                  start-placeholder="Inicio" end-placeholder="Fim">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :sm="24" :md="6">
            <el-form-item prop="status" label="Status">
              <el-select v-model="ruleForm.status" clearable style="width: 100%;">
                <el-option label="Concluída" value="succeeded" />
                <el-option label="Pendente" value="pending" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :sm="6" :xs="24">
            <el-form-item prop="payment_adjust_type_id" label="Descrição do ajuste">
              <el-select
                  v-model="ruleForm.payment_adjust_type_id"
                  clearable
                  style="width: 100%"
              >
                <el-option
                    :label="t.name"
                    :value="t.id"
                    v-for="t in typesAdjust"
                    :key="t.id"
                />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row type="flex" class="row-bg" justify="end">
          <el-col :xs="24" :span="15">
            <el-button icon="el-icon-download" @click='searchTable()' type="default" size="large" style="float: right; margin-right: 20px" :disabled="!statusClearFilter">
              Exportar
            </el-button>
            <el-button v-if="statusClearFilter" @click='clearSearch' type="default" size="large" style="float: right; margin-right: 20px">
              Limpar Filtros
            </el-button>
          </el-col>
        </el-row>
      </div>
    </el-form>
  </div>
</template>

<script>
import SelectSearchGerenteMarketplace from "@/app/components/GerenteMarketplace/SelectSearchGerenteMarketplace.vue";
import SelectSearchMarketplace from "@/app/components/Marketplace/SelectSearchMarketplace";
import SelectSearchDepartamentStore from "@/app/components/EstabelecimentoComercial/SelectSearchDepartamentStore";
import {mapGetters} from "vuex";
import {getTypeAdjust} from "../../../Financial/services";
import {getErrorFilds, makeErrorFilds} from "../../../../plugins/utils";

export default {
  name: "FilterBoxTransation",
  data () {
    return {
      ruleForm: {
        marketplace_id: null,
        department_store_id: null,
        payment_adjust_type_id: null,
        status: null,
        init_date: null,
        init_date_payment: null,
      },
      viewFilter: false,
      typesAdjust: [],
    }
  },
  components: {
    SelectSearchDepartamentStore,
    SelectSearchGerenteMarketplace,
    SelectSearchMarketplace,
  },
  props: {
    currentPage: {
      type: Number,
      default: 1
    },
    type: {
      type: Number,
      default: 0
    }
  },
  computed: {
    ...mapGetters('Auth', ['currentUser']),
    statusClearFilter: function () {
      if (this.ruleForm.department_store_id ||
          this.ruleForm.marketplace_id ||
          this.ruleForm.payment_adjust_type_id ||
          this.ruleForm.status ||
          this.ruleForm.init_date ||
          this.ruleForm.init_date_payment
      ) {
        console.log('true')
        return true
      }
      console.log('false')
      return false
    }
  },
  methods: {
    async getTypesAdjust() {
      try {
        this.loadingPage = true;
        this.error = {};
        let response = await getTypeAdjust();
        this.typesAdjust = response.data.data;
      } catch (e) {
        this.error = getErrorFilds(e);
        this.$message({
          showClose: true,
          message: makeErrorFilds(e)[Object.keys(makeErrorFilds(e))[0]],
          type: "error",
        });
      } finally {
        this.loadingPage = false;
      }
    },
    clearSearch () {
      this.viewFilter = false
      this.ruleForm = {
        marketplace_id: null,
        department_store_id: null,
        payment_adjust_type_id: null,
        status: null,
        init_date: null,
        init_date_payment: null,
      }
      this.$emit('filter', `?page=${this.currentPage}`)
    },
    searchTable () {
      let query = `?page=${this.currentPage}`

      if (this.ruleForm.marketplace_id) {
        query = `${query}&marketplace_id=${this.ruleForm.marketplace_id}`
      }
      if (this.ruleForm.department_store_id) {
        query = `${query}&department_store_id=${this.ruleForm.department_store_id}`
      }
      if (this.ruleForm.payment_adjust_type_id) {
        query = `${query}&payment_adjust_type_id=${this.ruleForm.payment_adjust_type_id}`
      }
      if (this.ruleForm.status) {
        query = `${query}&status=${this.ruleForm.status}`
      }
      if (this.ruleForm.init_date_payment) {
        query = `${query}&init_date_payment=${this.ruleForm.init_date_payment[0]}&finish_date_payment=${this.ruleForm.init_date_payment[1]}`
      }
      if (this.ruleForm.init_date) {
        query = `${query}&init_date=${this.ruleForm.init_date[0]}&finish_date=${this.ruleForm.init_date[1]}`
      }
      this.$emit('filterExport', query,this.ruleForm.tipo_transaction)
    }
  },
  async mounted() {
    await this.getTypesAdjust();
    if (this.$can('2|4|5')) {
      this.ruleForm.marketplace_id = this.currentUser.marketplace_id
    }
    if (this.$can('5')) {
      this.$set(this.ruleForm, 'department_store_id', this.currentUser.department_store_id)
      this.ruleForm.department_store_id = this.currentUser.department_store_id

      this.$set(this.ruleForm, 'marketplace_id', this.currentUser.department_store.marketplace_id)
      this.ruleForm.marketplace_id = this.currentUser.department_store.marketplace_id
    }
  }
}
</script>

<style scoped>

</style>
